import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { PRODUCT_NAME, tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="border-b border-arena bg-crudo" data-id="element-128" data-mp="3o9trxz6mahzz">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:py-9" data-id="element-129" data-mp="3jah4pdbu38wv">
        <SectionHeader id="solucion" eyebrowTone="olive" eyebrow="La solución que estabas buscando — un sistema 6 en 1" title="6 tomos en un solo sistema, creados para aprender macramé desde cero." data-id="element-130" data-mp="3j8w8zkds9jxf" />
        <p className="mt-2 text-center text-sm font-extrabold text-terracota sm:text-base" data-id="element-131" data-mp="auxeyoadg8mk">
          🧶 {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-sm leading-snug text-marron/80" data-id="element-132" data-mp="5wm3ya8cbs2r">
          No es simplemente otro ebook de macramé. Es una ruta de aprendizaje
          que organiza todo lo que necesitas para comprender qué aprender
          primero, practicar los nudos esenciales y avanzar hacia proyectos
          completos con mejores terminaciones.
        </p>

        <ol className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-133" data-mp="3b8xd5uytn4l4">
          {tomos.map((tomo, i) => <li key={tomo.title} className="flex gap-2.5 rounded-xl border border-arena bg-arena/30 p-3" data-id="element-134" data-mp="3fb0ydbbalnjl" data-mpi={i}>
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-terracota font-serif text-lg text-crudo" data-id="element-135" data-mp="3kbgajzju8ozz">
                {i + 1}
              </span>
              <div data-id="element-136" data-mp="3u7rpkxatbsy4">
                <p className="text-[0.7rem] font-bold uppercase text-olive" data-id="element-137" data-mp="3u79w28fjbstw">TOMO {i + 1}</p>
                <h3 className="text-sm font-extrabold leading-tight text-marron" data-id="element-138" data-mp="2uyhkufrhl85">{tomo.title}</h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-marron/80 sm:text-sm" data-id="element-139" data-mp="6ufntq30imed">{tomo.desc}</p>
              </div>
            </li>)}
        </ol>

        <CtaBlock note="" data-id="element-140" data-mp="gtey1d3feq3h" />
      </div>
    </section>;
}